export enum ApiResponseCode {
    Undefined = 0,
    Success = 1,
    CustomerNotFound = 2,
    InvalidCredential = 3,
    EmptyCredential = 4,
    ClientIsOffline = 5,
    CustomerIsNotLogin = 6,
    AlreadyLogged = 7,
    TokenIsNotRecognized = 8,
    WrongToken = 9,
    InnerServerError = 10,
    Error = 11,
    ClientNotFound = 12,
    CustomerIsNotAllowed = 13,
    UserNotFound = 14,
    CustomerIsLocked = 15,
    NotValidUserOrPsw = 16,
    YourPasswordHasExpierd = 17,
    InvalidBranchID = 38,
    Unauthorized = 49,
    InvalidIDOrPassport = 50,
    ServiceIsInactive = 70
}


export enum ClaimType {
    CanEnterSettings = 'CanEnterSettings',
    CanDefineScopeOfActivity = 'CanDefineScopeOfActivity',
    CanAddOrEditDepartments = 'CanAddOrEditDepartments', // deleted - only for SU
    CanAddNewBusinessOrBranch = 'CanAddNewBusinessOrBranch', // deleted - only for SU
    CanEditBusinessOrBranch = 'CanEditBusinessOrBranch', // only for Branch, edit business - only for SU
    CanAddNewPatient = 'CanAddNewPatient',
    CanEditPatient = 'CanEditPatient',
    CanEditPatientMedications = 'CanEditPatientMedications',
    CanEditPatientAnamneza = 'CanEditPatientAnamneza',
    CanEditPatientRemarks = 'CanEditPatientRemarks',
    CanViewPatientMedicalData = 'CanViewPatientMedicalData',
    CanViewMedicalWarningIndicators = 'CanViewMedicalWarningIndicators',
    BlockAccessForOtherTherapists = 'BlockAccessForOtherTherapists',
    CanEditConfidentialPatients = 'CanEditConfidentialPatients',
    CanEditPermissionGroup = 'CanEditPermissionGroup',
    CanCreateRetroAppointment = 'CanCreateRetroAppointment',
    CanAddorEditBlocks = 'CanAddorEditBlocks',
    CanDeleteCustomerDocument = 'CanDeleteCustomerDocument',
    CanEditVisitSummary = 'CanEditVisitSummary',
    CanViewAuditReport = 'CanViewAuditReport',
    RequiredRoomInAppointment = 'RequiredRoomInAppointment',
    PreventAppointmentDurationChange = 'PreventAppointmentDurationChange',
    PreventAppointmentTimeChange = 'PreventAppointmentTimeChange',
    PreventAppointmentCancellation = 'PreventAppointmentCancellation'
}



export enum EntityTypes {
    Undefined = 0,
    Customer = 1,
    Supplier = 2,
    SupplierContact = 3,
    PhoneBookContact = 4,
    SchedulerEvent = 5,
    Branch = 6,
    BranchDepartment = 7,
    Business = 8,
    ClaimMetadata = 9,
    ClaimResourcePolicy = 10,
    CustomerMedicalInfo = 11,
    LogIn = 12,
    LogOut = 13,
    SchedulerEventRef = 14,
    SchedulerTempWaitList = 15,
    SchedulerWaitingList = 16,
    User = 17,
    UserBranchDepartment = 18,
    FileMetaData = 19,
    PriceListCode = 20,
    SummaryEvent = 21,
    EntityMetadataFieldBusiness = 22,
    SchedulerBlock = 23,
    SchedulerOpen = 24,
    SchedulerBlockRecurrence = 25,
    SchedulerOpenRecurrence = 26,
    Scheduler = 27,
    PriceListRef = 28,
    SchedulerResource = 29,
    TreatmentParent = 30,
    Treatment = 31,
    Count
}


export enum WaitListItemSatus {
    Unknown = 0,
    Pending = 1,
    Vacant = 2,
    Expired = 3
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
}

export enum TerminologyType {
    Business = 1,
    Therapist = 2
}

export enum SchedulerRecordType {
    NotSet = 0,
    General = 1,
    User = 2,
    Branch = 3,
    Resource = 4
}

export enum SchedulerViewType {
    Day = 0,
    Week = 1,
    Month = 2,
    Agenda = 3,
    Custom = 4,
    WorkWeek = 5,
    Timeline = 6,
    TimelineWeek = 7,
    TimelineWorkWeek = 8,
    TimelineMonth = 9,
    CustomAgenda = 12,
    CustomDay = 13,
    CustomWeek = 14,
    ToDoView = 15
}

export enum SchedulerEventType {
    NotSet = 0,
    Appointment = 1,
    Remark = 2,
    Block = 3,
    Open = 4,
    Holiday = 5
}

export enum Gender {
    NotSet = 0,
    Male = 1,
    Female = 2
}

export enum EventShowStatus {
    All = 0,
    History = 1,
    Today = 2,
    Future = 3,
    Confirmed = 4,
    Show = 5,
    NoShow = 6,
    Deleted = 7
}

export enum MaritalStatus {
    NotSet = 0,
    Single = 1,
    Married = 2,
    Divorced = 3,
    Widower = 4
}


export enum TreatmentType {
    Treatment = 1,
    Product = 2,
    Series = 3,
    Plan = 4
}

export enum TreatmentStatus {
    Undefined = 0,
    ToDo = 1,
    Done = 2,
    Removed = 3, // used to filter customer treatments grid
    UnscheduledTreatments = 4,
    InProgress = 5
}

export enum IdentityValidationType {
    IsraelTZ = 1,
    Passport = 2,
    NotSet3 = 3,
    Empty = 99
}



export enum CustomerStatus {
    Inactive = 0,
    Active = 1,
    Temp = 2
}

// remove if unused
export enum ConfirmBoxAction {
    Unknown = 0,
    DeleteAppointment = 1,
    DeleteWaitlistItem = 2,
    Message = 3
}

export enum customerFieldType {
    Undefined = 0,
    Text = 1,
    Date = 2,
    DropDown = 3,
    Integer = 4,
    CheckBox = 5
}


export enum ConfirmeAppointmentTypes {
    None = 0,
    Confirmed = 1,
    ConfirmedOnlineByPatient = 2,
    Decline = 4
}

export enum PaymentRequestProviders {
    Undefined = 0,
    Pelecard = 1,
    Bit = 2
}

export enum FileUploadType {
    Undefined = 0,
    Image = 1,
    Document = 2
}

export enum FormTypes {
    Undefined = 0,
    Form = 1,
    Interactive = 2,
    Treatment = 3
}

export enum FillFormTypes {
    FillInPatientCard = 1,
    Send = 2
}

